export default __webpack_public_path__ + "navigation-examples-building-extrusion-1200-6beebbadbb10ba473f8c636af572960e.webp";